module.exports = __webpack_public_path__ + "static/media/icon-free-storage.cc91578c.svg";